<!-- <a  matTooltip="{{this.translate.data['TOOLTIPEDITPLATFORMGROUPROLE'] | translate}}"  [routerLink]="routerLinkEditPlatformGroupRole">
    <mat-icon aria-hidden="false" aria-label="icon">{{icon_edit}}</mat-icon>
</a> -->
<!-- <a matTooltip="{{this.translate.data['TOOLTIPVIEWTENANTGROUPROLEPERMISSIONS'] | translate}}" (click)="viewTenantPermissions()">
  <mat-icon aria-hidden="false" aria-label="icon">{{icon_view}}</mat-icon>
</a>
<a matTooltip="{{this.translate.data['TOOLTIPDELETETENANTGROUPROLE'] | translate}}" (click)="deleteTenantGroupRole()">
  <mat-icon aria-hidden="false" aria-label="icon">{{icon_delete}}</mat-icon>
</a> -->

<a>
  <button mat-raised-button class="btn btn-squirrel pull-left" style="margin-top: 6px;" matTooltip="{{this.translate.data['TOOLTIPVIEWTENANTGROUPROLEPERMISSIONS'] | translate}}" (click)="viewTenantPermissions()">Berechtigungen</button>
</a>
<a *ngIf="icon_delete">
  <button mat-raised-button class="btn btn-squirrel pull-left" style="margin-top: 6px;" matTooltip="{{this.translate.data['TOOLTIPDELETETENANTGROUPROLE'] | translate}}" (click)="deleteTenantGroupRole()">Löschen</button>
</a>
<a *ngIf="!icon_delete">
  <button mat-raised-button class="btn btn-squirrel pull-left" style="margin-top: 6px;" matTooltip="Zuweisung der Gruppe aufheben" (click)="removeTenantGroupRole()">Aufheben</button>
</a>


